// Types
import type { OfferDiscount } from "src/types/offer";
import type { ItemNameCategoryDiscount } from "src/types/offer/ItemNameCategoryDiscount";

// Utils
import { formatOfferTypeToolTip, type FormatterOptions } from "src/utils/formatters";
import { formatOfferDiscountItems } from "../../utils/OfferListView.utils";

// Components
import { Box } from "@mui/material";
import type { OfferScenario } from "src/types/offer/OfferScenario";
import type { MarketingActionVariantEnum } from "src/utils/variants";

export function renderOfferTypeTooltipWithProducts(
    variants: MarketingActionVariantEnum[],
    scenario: Pick<OfferScenario, "discount"> & {
        items?: (Pick<ItemNameCategoryDiscount, "name" | "categoryName"> &
            Pick<OfferDiscount, "percentDiscount">)[];
    },
    formatOptions: FormatterOptions,
    { withOfferType = true }: { withOfferType?: boolean } = {}
): JSX.Element | string {
    const specialToolTip =
        withOfferType && variants && formatOfferTypeToolTip(variants, scenario, formatOptions);
    const itemsTooltip =
        scenario.items?.length > 0
            ? formatOfferDiscountItems(scenario.items, formatOptions.translateRaw)
            : "";

    if (!specialToolTip && !itemsTooltip) {
        return "";
    }

    return (
        <Box>
            {specialToolTip && <Box>{specialToolTip}</Box>}
            <Box style={{ whiteSpace: "pre-line" }}>
                <p>{itemsTooltip}</p>
            </Box>
        </Box>
    );
}
